import React from "react";
import MetaTags from "react-meta-tags";
import Navbar from "../components/Navbar";
import { Link, useLocation, useNavigate, Navigate } from "react-router-dom";
import "../styles/testsolutionpage.css";

export default function TestSolutionPage() {
  const navigate = useNavigate();
  const location = useLocation();

  // session guard (same logic as old page)
  const itemStr = localStorage.getItem("isLogin");
  const item = itemStr ? JSON.parse(itemStr) : null;
  const now = new Date();
  if (!itemStr || (item && item.expiry < now.getTime())) {
    return <Navigate to="/login" replace />;
  }

  // safe defaults if user refreshed the page
  const catName = location.state?.catName || "Online Test";
  const quesData = Array.isArray(location.state?.quesData) ? location.state.quesData : [];
  const ansArray = Array.isArray(location.state?.ansArray) ? location.state.ansArray : [];

  return (
    <>
      <MetaTags>
        <title>{catName} Online Quiz Answers - PolyQuiz</title>
        <meta name="description" content="Quiz solutions and correct answers." />
      </MetaTags>

      <Navbar />

      <main className="ts-root">
        <header className="ts-header">
          <h1 className="ts-title">{catName} – Quiz Solutions</h1>
          <p className="ts-subtitle">Review your choices and the correct answers.</p>
        </header>

        <section className="ts-section">
          {quesData.map((q, idx) => {
            const selected = ansArray[idx];
            const isCorrect = (opt) => opt === q.Answer;

            return (
              <article key={q.QuestionId || idx} className="sol-card">
                <div className="sol-head">
                  <div className="sol-qno">Que. {idx + 1}</div>
                  <div className="sol-qtext">{q.Question}</div>
                </div>

                {q.Image1 && (
                  <div className="sol-image">
                    <img
                      src={`https://epolylearning.com/QuestionImages/${q.QuestionId}-1.png`}
                      alt=""
                    />
                  </div>
                )}
                {q.Image2 && (
                  <div className="sol-image">
                    <img
                      src={`https://epolylearning.com/QuestionImages/${q.QuestionId}-2.png`}
                      alt=""
                    />
                  </div>
                )}

                <div className="sol-options">
                  <OptionRow
                    id={`q${idx}-a`}
                    text={q.Option1}
                    checked={selected === q.Option1}
                    correct={isCorrect(q.Option1)}
                  />
                  <OptionRow
                    id={`q${idx}-b`}
                    text={q.Option2}
                    checked={selected === q.Option2}
                    correct={isCorrect(q.Option2)}
                  />
                  <OptionRow
                    id={`q${idx}-c`}
                    text={q.Option3}
                    checked={selected === q.Option3}
                    correct={isCorrect(q.Option3)}
                  />
                  <OptionRow
                    id={`q${idx}-d`}
                    text={q.Option4}
                    checked={selected === q.Option4}
                    correct={isCorrect(q.Option4)}
                  />
                  <OptionRow
                    id={`q${idx}-e`}
                    text={q.Option5}
                    checked={selected === q.Option5}
                    correct={isCorrect(q.Option5)}
                  />
                </div>



              </article>
            );
          })}

          {quesData.length === 0 && (
            <div className="ts-empty">
              No solution data available.{" "}
              <button className="linklike" onClick={() => navigate(-1)}>
                Go back
              </button>
              .
            </div>
          )}
        </section>

        <footer className="ts-actions">
          <button className="" onClick={() => navigate(-1)}>
            ⟵ Back to Analysis
          </button>
          <Link to="/" className="primary-btn">
            Go to Tests
          </Link>
        </footer>
      </main>
    </>
  );
}

/* ---------- Small presentational piece for a single option ---------- */
function OptionRow({ id, text, checked, correct }) {
  return (
    <label className={`sol-row ${correct ? "correct" : ""}`}>
      <input className="sol-radio" type="radio" id={id} checked={!!checked} readOnly disabled />
      <span className="sol-text">{text}</span>
      {correct && (
        <span className="sol-check" aria-label="Correct answer" title="Correct answer">
          <svg viewBox="0 0 24 24" width="16" height="16" role="img" aria-hidden="true">
            <circle cx="12" cy="12" r="11" fill="none" stroke="currentColor" strokeWidth="2" />
            <path
              d="M7 12l3 3 7-7"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      )}
    </label>
  );
}
